export default __webpack_public_path__ + "static/yulia-bobko-67c1a20f4449f3d0dc8aeadb2f17e583.png";